import React, { FC, useState } from 'react';
import Input from 'components/Input';
import Message from 'components/Message';
import Modal from 'components/Modal';
import './style.scss';

type CashierNameModalProps = {
  setIsOpen: (open: boolean) => void;
  isOpen: boolean;
  modalRef: React.RefObject<HTMLDivElement>;
  handleSaveCashierName: (cashierName: string) => Promise<void>;
  defaultName: string;
};

const CashierNameModal: FC<CashierNameModalProps> = ({
  setIsOpen,
  isOpen,
  modalRef,
  handleSaveCashierName,
  defaultName,
}) => {
  const [cashierName, setCashierName] = useState(defaultName);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const handleOnCancel = () => {
    setCashierName(defaultName);
    setIsOpen(false);
    setError(undefined);
  };

  const saveCashier = () => {
    setError(undefined);
    setLoading(true);
    handleSaveCashierName(cashierName)
      .then(() => setIsOpen(false))
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      handleOnCancel={handleOnCancel}
      handleOnConfirm={() => saveCashier()}
      header="Accept in person payments"
      confirmlabel="Save"
      denyLabel="Cancel"
      visible={isOpen}
      className="cashier-name-modal"
      modalRef={modalRef}
      confirmButtonProps={{ disabled: loading || !cashierName }}>
      <Input
        label="Cashier name"
        placeholder="First Last"
        value={cashierName}
        name="cashier-name"
        type="text"
        rules={{ required: true }}
        onChange={({ target }) => setCashierName(target.value)}
        onBlur={() => setCashierName(cashierName.trim())}
      />
      {error && (
        <Message type="failed" showMessage={!!error} setShowMessage={() => setError(undefined)}>
          {error}
        </Message>
      )}
    </Modal>
  );
};

export default CashierNameModal;
